import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import styled from 'styled-components';
import styles from '../shared/styles';
import Colors from '../../../../styles/colors';
import { RowDivision } from '../shared/styled-components';
import { getLandingPageUrl } from '../../../../helpers/soundcasts';
import { FlexDiv, HigherPlanTag } from '../../../../styles/styled';
import { canUserAccessFeature } from '../../../../helpers/userinfoHelper';

export default class Status extends Component {
  constructor(props) {
    super(props);

    this.state = {
      miniSubheaderText: '',
      privateAvailable: false,
    };
  }

  componentDidMount() {
    // verify of soundcast feature is accessible
    let privateAvailable = canUserAccessFeature('SOUNDCAST_PRIVATE');

    this.setState({
      privateAvailable,
    });
  }

  render() {
    const {
      soundcastId,
      public: isPublic,
      published,
      publicText,
      privateText,
      viewLinks,
      onStatusChange,
    } = this.props;

    const {
      privateAvailable,
    } = this.state;

    const StatusLink = styled.a`
      color: ${Colors.mainOrange};
      font-weight: normal;
      font-size: 1.4rem;
      margin-left: 12px;
      z-index: 10;

      &:hover,
      &:visited {
        text-decoration: underline;
        color: ${Colors.mainOrange};
      }
    `;
    const miniSubheaderText =
      viewLinks && isPublic && !isEmpty(soundcastId) ? (
        <StatusLink target="_blank" href={getLandingPageUrl(soundcastId, published)}>
          Landing Page Preview
        </StatusLink>
      ) : null;

    return (
      <RowDivision className="row">
        <div id="status" className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <RadioButtonGroup
            id="landing-status"
            name="Soundcast public status"
            defaultSelected={isPublic}
            onChange={(_e, value) => onStatusChange('landingPage', value)}>
            <RadioButton
              value={true}
              label={
                <FlexDiv alignItems="center">
                  {publicText} {miniSubheaderText}
                </FlexDiv>
              }
              labelStyle={styles.podcastTitleText}
              style={styles.radioButton}
            />
            <RadioButton
              value={false}
              label={
                <FlexDiv alignItems="center">
                  {privateText} {!privateAvailable && <HigherPlanTag className="margin-one-left" />}
                </FlexDiv>
              }
              labelStyle={styles.podcastTitleText}
              style={styles.radioButton}
              disabled={!privateAvailable}
            />
          </RadioButtonGroup>
        </div>
      </RowDivision>
    );
  }
}

Status.propTypes = {
  soundcastId: PropTypes.string,
  public: PropTypes.bool,
  published: PropTypes.bool,
  publicText: PropTypes.string,
  privateText: PropTypes.string,
  viewLinks: PropTypes.bool,
  onStatusChange: PropTypes.func,
};

Status.defaultProps = {
  soundcastId: '',
  public: true,
  published: false,
  publicText: 'Public soundcast',
  privateText: 'Private soundcast',
  viewLinks: false,
  onStatusChange: () => {},
};
